const countryEnglandOnly: { [key: string]: string } = {
  EN: 'England',
};

export default countryEnglandOnly;
